
import { AppBar, Button, Link, Toolbar, Typography } from '@mui/material';
import React from 'react';
import NavBarProps from '../../models/navbar-props.model';
import { makeStyles } from "tss-react/mui";
import { useKeycloak } from '@react-keycloak/web';
import axios from 'axios';



const NavBar: React.FC<{ props: NavBarProps }> = ({ props }) => {
	const { keycloak } = useKeycloak();
	const base = 'https://wsro-dev.cremedatafoundry.com/';
	const qapLogoutURL = 'https://analytics.cremedatafoundry.com';
	const logout = 'https://69zohaghu8.execute-api.eu-west-1.amazonaws.com/dev/qap_logout/';
	const qlikLogoutURL = 'https://e9f8u2ddee.execute-api.eu-west-1.amazonaws.com/prod/qap_logout/';
	const idpLogoutURL = 'https://login.cremeglobal.com/realms/qlik-qap/protocol/openid-connect/logout';


	const useStyles = makeStyles()((theme: any) => ({
		ssoLoginButton: {
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			padding: theme.spacing(2),
			fontSize: theme.typography.body2.fontSize,
			fontWeight: 'bold',
			'&:hover': {

				backgroundColor: `#f72a42 !important`,
				color: 'white',
				borderRadius: '2px',
			}
		}
	}));

	// sign out button
	const signOut = () => {
		// https://login.cremeglobal.com/realms/qlik-qap/protocol/openid-connect/logout
		// const logoutState = fetch.get(`https://login.cremeglobal.com/realms/qlik-qap/protocol/openid-connect/logout?redirect_uri=${window.location.origin}/sign-up`);
		logoutHandler();
		localStorage.clear();
		
		// fetch(`https://login.cremeglobal.com/realms/qlik-qap/protocol/openid-connect/logout`, {
		// 	method: 'POST',
		// 	headers: {
		// 		'Content-Type': 'application/json',
		// 		'Accept': 'application/json',
		// 		'Access-Control-Allow-Origin': '*',
		// 		'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
		// 		'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
		// 		'Access-Control-Allow-Credentials': 'true',
		// 	},
		// }).then((response) => {
		// 	console.log(response);
		// 	// window.location.href = 'https://login.cremeglobal.com/realms/qlik-qap/protocol/openid-connect/logout?redirect_uri=' + window.location.origin + '/sign-up';
		// });
	}

	const logoutHandler = () => {
			qapLogout();
	};


	const qapLogout = async () => {
		try {
			/*
			* Stage 1
			* Initiate the invalidation of the Qlik session by retrieving the
			* logged-in user's id and passing that on to the agent with access to the
			* "trusted zone" APIs.
			*/
			const headers = {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
				'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
				'Access-Control-Allow-Credentials': 'true',
			};
			const userData = await axios.get(`${qapLogoutURL}/qps/user`, { withCredentials: true, headers: headers });
			await axios.post(qlikLogoutURL, userData.data).catch((error) => {
				invalidateIDP();
			});
			invalidateIDP();
		} catch (err) {
			console.error(err);
		}
	};

	const invalidateIDP = () => {
		/*
		* Stage 2
		* Initiate the invalidation of the KeyCloak session by redirecting the
		* subdocument shown in the Qlik iFrame to the KeyCloak logout endpoint.
		* The cookies previously set by KeyCloak are used by its logout endpoint
		* to know who's logging out.
		*/

		// const iframeElem = document.getElementById('qLikIFrame');
		// const logout_url = `${idpLogoutURL}?redirect_uri=${window.location.origin}/sign-up`;
		// iframeElem?.setAttribute('src', logout_url);
		// route to sign up page
		// window.location.href = `${window.location.origin}/sign-up`;
		keycloak.logout({ redirectUri: `${window.location.origin}/sign-up` }).then(() => {
		});
	};


	const { classes } = useStyles();

	return (
		<AppBar position="static" color='primary'>
			<Toolbar>
				<Typography component={'span'} variant={'body2'}>
					<img src={props.logoLink} alt={props.logoAlt} height={70} width={70} />
				</Typography>
				<Typography variant={'h6'} component={'div'} sx={{ flexGrow: 1 }}>
				</Typography>
				<Button color="secondary" onClick={signOut} className={classes.ssoLoginButton} >{'Sign Out'}</Button>
			</Toolbar>
		</AppBar>
	);
}

export default NavBar;